import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import moment from 'moment'
import vuetify from './plugins/vuetify'
import IdleVue from 'idle-vue'
import VuePapaParse from 'vue-papa-parse'
import vuetify_datetime_picker from './plugins/vuetify_datetime_picker'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
// import VueJsonPretty from 'vue-json-pretty'
import JsonViewer from 'vue-json-viewer'
import VueClipboard from 'vue-clipboard2'

import drag from 'v-drag'

// import { DraggablePlugin, DraggableDirective } from '@braks/revue-draggable'
// Vue.use(DraggablePlugin)

import variables from '@/styles/variables.scss'

import 'drawflow/dist/drawflow.min.css'

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import './styles/customs.scss'
import './styles/spacing.scss'
import '@/utils/paste_handler'

// import 'vue-json-pretty/lib/styles.css'

Vue.use(drag)

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
// Vue.component('vue-json-pretty', VueJsonPretty)

Vue.config.productionTip = false

Vue.filter('decimalFormat', num => {
  if (typeof num == 'number') {
    return Number(num).toLocaleString(undefined, { minimumFractionDigits: 0 })
  } else {
    return '-'
  }
})
Vue.filter('numberToPercent', num => {
  let result = num ? `${num.toFixed(2)}%` : `0%`

  // const data = 100
  // if (result === `${data.toFixed(2)}%`) {
  //   result = '100%'
  // }

  return result
})

Vue.filter('datetime', date => {
  if (date) return moment(date).format('YYYY-MM-DD HH:mm:ss')
  else return '-'
})
Vue.filter('datetimeFormat', date => {
  if (date) return moment(date).format('ddd, DD MMMM YYYY HH:mm')
  else return '-'
})
Vue.filter('datetimeFormatNoDate', date => {
  if (date) return moment(date).format('DD MMMM YYYY HH:mm')
  else return '-'
})
Vue.filter('datetimeFormatWithSeconds', date => {
  if (date) return moment(date).format('ddd, DD MMMM YYYY HH:mm:ss')
  else return '-'
})
Vue.filter('datetimeFormatNoTime', date => {
  if (date) return moment(date).format('ddd, DD MMM YYYY')
  else return '-'
})
Vue.filter('timeFormat', date => {
  return moment(date).format('HH:mm')
})
Vue.filter('timeFormatWithSeconds', date => {
  return moment(date).format('HH:mm:ss')
})
Vue.filter('datetimeFormatWithMillisecondsNoDate', date => {
  if (date) return moment(date).format('YYYY-MM-DD HH:mm:ss.SSS')
  else return '-'
})

Vue.filter('duration', x => {
  const num = parseFloat(x)
  if (isNaN(num)) {
    return '-'
  }

  let _s = num
  const units = { day: 864e2, hour: 3600, minute: 60, second: 1 },
    str = Object.entries(units).reduce((r, [unit, multiplier]) => {
      if (_s >= multiplier) {
        const count = (_s / multiplier) | 0,
          tail = count > 1 ? 's' : ''
        r.push([count, unit + tail])
        _s = _s % multiplier
      }
      return r
    }, [])
  return str.flat().join(' ')
})
Vue.filter('minToHour', n => {
  const a = `0${(n / 60) ^ 0}`.slice(-2) + ':' + ('0' + (n % 60)).slice(-2)
  return a
})

Vue.filter('reportDate', item => {
  const result = moment(item.text).format(item.format)

  return result
})
Vue.filter('reportNumber', item => {
  let result = item.text ? `${item.text.toFixed(item.decimal)}` : item.text

  return result
})
Vue.filter('reportNumber1', item => {
  if (typeof item.text == 'number') {
    const data = parseFloat(item.text.toFixed(item.decimal))
    const minimumFractionDigits = item.decimal === 0 ? 0 : item.decimal

    return Number(data).toLocaleString(undefined, {
      minimumFractionDigits
    })
  } else {
    return item.text
  }
})
Vue.filter('reportNumberToPercent', item => {
  let result = item.text ? `${item.text.toFixed(item.decimal)}%` : `0%`

  // const data = 100
  // if (result === `${data.toFixed(item.decimal)}%`) {
  //   result = '100%'
  // }

  return result
})

Vue.filter('convertDatetimePicker', datetime => {
  return moment(datetime, Vue.prototype.$datetimeFormatDefault).format(
    Vue.prototype.$datetimeFormatShort
  )
})
Vue.filter('convertDatePicker', date => {
  return moment(date, Vue.prototype.$dateFormatDefault).format(
    Vue.prototype.$dateFormatShort
  )
})

Vue.filter('status', code => {
  switch (code) {
    case 'ok':
      return '<span class="icon-table"><i class="fas fa-book-open"></i></span>'
    case 'test_set':
      return '<span class="icon-table"><i class="fas fa-vial"></i></span>'
    case 'not_sure':
      return '<span class="icon-table"><i class="fas fa-question"></i></span>'
    default:
      return '<span class="icon-table"><i class="fas fa-undo-alt"></i></span>'
  }
})

Vue.filter('readableAmount', number => {
  if (number < 1000) {
    return number.toString()
  } else if (number < 10000) {
    const thousands = (number / 1000).toFixed(1)
    return `${thousands}K`
  } else if (number < 1000000) {
    const thousands = Math.floor(number / 1000)
    return `${thousands}K`
  } else if (number < 10000000) {
    const millions = (number / 1000000).toFixed(1)
    return `${millions}M`
  } else {
    const millions = Math.floor(number / 1000000)
    return `${millions}M`
  }
})

Vue.filter('truncateMiddle', (inputString, maxLength) => {
  // Check if the input string is longer than the desired maximum length
  if (inputString.length > maxLength) {
    const ellipsis = ' . . . '
    const maxFirstPartLength = Math.floor((maxLength - ellipsis.length) / 2)
    const maxLastPartLength = maxLength - maxFirstPartLength - ellipsis.length

    const firstPart = inputString.slice(0, maxFirstPartLength)
    const lastPart = inputString.slice(-maxLastPartLength)

    return `${firstPart}${ellipsis}${lastPart}`
  }

  // Return the input string as is if it's already shorter than the desired maximum length
  return inputString
})

Vue.filter('getVariable', variable => {
  const general = store.getters['general/general']
  if (general[variable])
    return general[variable].replace(/^"/, '').replace(/"$/, '')
  else return variable
})

Vue.prototype.$getVoiceColor = [
  variables.voiceColor1,
  variables.voiceColor2,
  variables.voiceColor3,
  variables.voiceColor4,
  variables.voiceColor5
]
Vue.prototype.$getVoiceOutboundColor = [
  variables.voiceOutboundColor1,
  variables.voiceOutboundColor2,
  variables.voiceOutboundColor3,
  variables.voiceOutboundColor4,
  variables.voiceOutboundColor5
]
Vue.prototype.$getChatColor = [
  variables.chatColor1,
  variables.chatColor2,
  variables.chatColor3,
  variables.chatColor4,
  variables.chatColor5
]
Vue.prototype.$getGrayColor = [
  variables.grayColor1,
  variables.grayColor2,
  variables.grayColor3,
  variables.grayColor4,
  variables.grayColor5,
  variables.grayColor6,
  variables.grayColor7,
  variables.grayColor8,
  variables.grayColor9,
  variables.grayColor10
]
Vue.prototype.$getGreenGrayColor = [
  variables.greenColor1,
  variables.grayColor,
  variables.darkGrayColor
]

Vue.prototype.$getBrownGrayColor = [
  variables.brownColor1,
  variables.grayColor,
  variables.darkGrayColor
]

Vue.prototype.$getVoiceGrayColor = [
  variables.voiceColor1,
  variables.voiceColor2,
  variables.voiceColor3,
  variables.darkGrayColor
]

Vue.prototype.$getYellowColor = [
  variables.yellowColor1,
  variables.yellowColor2,
  variables.yellowColor3,
  variables.yellowColor4,
  variables.yellowColor5,
  variables.yellowColor6,
  variables.yellowColor7,
  variables.yellowColor8,
  variables.yellowColor9,
  variables.yellowColor10
]

Vue.prototype.$getLightGrayColor = variables.lightGrayColor

Vue.prototype.$datetimeFormatDefault = 'YYYY-MM-DD HH:mm'
Vue.prototype.$datetimeFormatShort = 'DD-MM-YYYY HH:mm'

Vue.prototype.$dateFormatDefault = 'YYYY-MM-DD'
Vue.prototype.$dateFormatShort = 'DD-MM-YYYY'

Vue.prototype.$timeFormatDefault = 'HH:mm'

Vue.prototype.$itemspage = [
  { value: 50, title: '50' },
  { value: 100, title: '100' },
  { value: 500, title: '500' },
  { value: 1000, title: '1,000' },
  { value: 5000, title: '5,000' }
]

Vue.prototype.$nodeNameUnique = ['api', 'code', 'input', 'gen_ai']

Vue.prototype.$nodeNoJump = [
  'add_retry',
  'clear_retry',
  'disconnect',
  'enter',
  'exit',
  'jump',
  'loop',
  'note',
  // 'page',
  'start',
  'chat_disconnect',
  'chat_start'
]

Vue.prototype.$nodeColor = [
  { bg: '#EA6964', text: '#4A4A4A' },
  { bg: '#F7D577', text: '#4A4A4A' },
  { bg: '#5AC49A', text: '#4A4A4A' },
  { bg: '#688AED', text: '#4A4A4A' },
  { bg: '#A26AC6', text: '#4A4A4A' },
  { bg: '#E17AB4', text: '#4A4A4A' },
  { bg: '#C8AC96', text: '#4A4A4A' },
  { bg: '#DDDDDD', text: '#4A4A4A' },
  { bg: '#FFFFFF', text: '#4A4A4A' }
]

Vue.prototype.$qcReason = [
  'Bad signal',
  'No human speech',
  'Unsupported language',
  'Out of scope',
  'Other'
]

const eventsHub = new Vue()

export const bus = new Vue()

Vue.use(VuePapaParse)
Vue.use(IdleVue, { eventEmitter: eventsHub, idleTime: 10000 })
Vue.use(VueClipboard)
Vue.use(JsonViewer)

new Vue({
  router,
  store,
  i18n,
  vuetify,
  vuetify_datetime_picker,
  render: h => h(App)
}).$mount('#app')
